const moment = require('moment-timezone');

export const localDatetime2Date = (data: any) => {
  // 从 JSON 数据中提取信息
  const { year, monthValue, dayOfMonth, hour, minute, second } = data;

  // JavaScript Date 对象的月份从0开始，所以需要将 monthValue 减去1
  const date = new Date(year, monthValue - 1, dayOfMonth, hour, minute, second);
  return date;
};

export const getDateWithT = (inputDate: string) => {
  // return new Date(date.replaceAll("T", " "))
  //   .toLocaleDateString()
  //   .replaceAll("/", "-");
  // 分割日期字符串
  const parts = inputDate.substring(0, inputDate.indexOf('T')).split('-');

  // 检查月份和日是否为单个数字，并在前面添加零
  const year = parts[0];
  const month = parts[1].length === 1 ? '0' + parts[1] : parts[1];
  const day = parts[2].length === 1 ? '0' + parts[2] : parts[2];

  // 重新组合日期字符串
  const formattedDate = year + '-' + month + '-' + day;

  return formattedDate;
};

export const formatDateToChinese = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${year}年${month}月${day}日`;
};

export const convertToShanghaiTime = (utcDateStr): Date => {
  return moment.utc(utcDateStr).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss');
  // const formatter = new Intl.DateTimeFormat("zh-CN", {
  //   timeZone: "Asia/Shanghai",
  //   year: "numeric",
  //   month: "2-digit",
  //   day: "2-digit",
  //   hour: "2-digit",
  //   minute: "2-digit",
  //   second: "2-digit",
  //   hour12: false,
  // });
};

export const date2DurationStr = (beginDate: Date, finishDate: Date) => {
  // 计算毫秒差
  const diffInMilliseconds = finishDate.getTime() - beginDate.getTime();

  // 计算不同单位的差值
  const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  // 计算年、月、日、时、分、秒
  const years = Math.floor(diffInDays / 365);
  const months = Math.floor((diffInDays % 365) / 30); // 假设每个月30天
  const days = diffInDays % 30;
  const hours = Math.floor(diffInHours % 24);
  const minutes = Math.floor(diffInMinutes % 60);
  const seconds = diffInSeconds % 60;

  // 构建结果字符串，按需显示各个单位
  let result = '';
  if (years > 0) {
    result += `${years}年`;
  }
  if (months > 0) {
    result += `${months}月`;
  }
  if (days > 0) {
    result += `${days}天`;
  }
  if (hours > 0) {
    result += `${hours}小时`;
  }
  if (minutes > 0) {
    result += `${minutes}分钟`;
  }
  // if (seconds > 0) {
  //   result += `${seconds}秒`;
  // }

  return result || '0秒'; // 如果没有任何差距，返回 '0秒'
};
